import { componentName, BadgeClass } from './BadgeClass';

customElements.define(componentName, BadgeClass);

export { BadgeClass, componentName };
